<div *ngIf="isPopupVisible" id="notification-popup" class="notification-popup" #popup>
  <!-- Notification Header -->
  <div class="notification-header">
    <!-- <div class="notification-header-close">
      <span class="action-icon"><i class="notification-bell" (click)="closeNotificationPopup()"></i></span>
    </div> -->
    <div class="notification-title">Notifications</div>
    <div class="notification-header-action">
      <span class="action-icon"><i class="e-close e-icons" (click)="closeNotificationPopup()"></i></span>
    </div>
  </div>

  <!-- New Actions Row -->
  <div class="notification-actions">
    <button class="action-button" (click)="handleMarkAllAsRead()">
      <i class="fa fa-check-circle"></i>
      Mark all as read
    </button>
    <button class="action-button" (click)="handleRemoveAllNotifications()">
      <i class="fa fa-trash-can"></i>
      Clear all
    </button>
  </div>

  <!-- Notification Items -->
  <div class="notification-item-container" [style.max-height]="containerHeight" (scroll)="onScroll($event)" #notificationContainer>
    <!-- Loader -->
    <div *ngIf="isLoading" class="loader-container">
      <div class="loader-class"></div>
    </div>

    <!-- No Notifications Message -->
    <div *ngIf="notifications.length === 0 && !isLoading" class="no-notifications">
      <div class="no-notifications-illustration">
        <i class="fa fa-bell"></i>
      </div>
      <div class="no-notifications-title">You're all caught up!</div>
      <div class="no-notifications-subtitle">No new notifications at the moment</div>
    </div>

    <!-- Notifications List -->
    <div *ngFor="let notification of notifications" class="notification-item">
      <div class="notification-content">
        <!-- <div class="notification-icon"> -->
        <!--<i class="e-icons e-border-box"></i>-->
        <!-- Add specific notification icon if necessary -->
        <!-- <img class="avatar" src="https://api.dicebear.com/6.x/initials/svg?seed={{notification?.payload?.AssigneeName || notification?.payload?.NameOfPerfomer || notification?.subscriber['firstName'] +  ' ' + notification?.subscriber['lastName']}}" alt="User Avatar">
        </div> -->
        <div class="notification-details" [ngClass]="{'clickable': hasValidUrl(notification)}" (click)="openNotification(notification)">
          <div [innerHtml]="(notification?.parsedPayload?.body || '') | contentPreview | async"></div>
          <div class="notification-time">{{ notification.createdAt | date : 'short' }}</div>
        </div>
        <div class="notification-action">
          <div class="notification-action-icons mark-icon" (click)="markAsRead(notification)">
            <span class="blue-dot" [ngClass]="{ read: notification.isRead }"></span>
          </div>
          <div class="notification-action-icons remove-icon" (click)="removeNotification(notification)">
            <i class="e-close e-icons" style="font-size: 10px"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
